import { render } from "./GivingForm4.vue?vue&type=template&id=4d9c8586&scoped=true"
import script from "./GivingForm4.vue?vue&type=script&lang=js"
export * from "./GivingForm4.vue?vue&type=script&lang=js"

import "./GivingForm4.vue?vue&type=style&index=0&id=4d9c8586&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9c8586"]])

export default __exports__